import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/view/pages/index.vue'),
      meta: {
        keepAlive: true,
        title: '首页'
      }
    },
    {
      path: '/investor',
      name: 'Investor',
      component: () => import('@/view/pages/investor.vue'),
      meta: {
        keepAlive: true,
        title: '投资者关系'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js